import { render, staticRenderFns } from "./ArticleCategoryView.vue?vue&type=template&id=7fd12388&"
import script from "./ArticleCategoryView.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports